import o from"lodash/isNil";var r=function(r){var i,n=function(r){var a;(void 0===i||!o(r.value)&&r.value>i)&&(i=r.value),null===(a=r.children)||void 0===a||a.forEach((function(o){n(o)}))};return n(r),i};export{r as getMaxValue};
